import { createInertiaApp, type ResolvedComponent } from '@inertiajs/svelte'
import 'bootstrap/js/dist/collapse'
import { mount } from 'svelte'
import Layout from "../../views/layouts/application.svelte"

createInertiaApp({
  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    //const pages = import.meta.glob<ResolvedComponent>('../pages/**/*.svelte', {
    //  eager: true,
    //})
    //const page = pages[`../pages/${name}.svelte`]

    const pages = import.meta.glob('../../views/**/*.svelte', {
      eager: true,
    })

    const page = pages[`../../views/${name}.svelte`]

    if (!page) {
      console.error(`Missing Inertia page component: '${name}.svelte'`)
    }
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.svelte'`)
    }

    // To use a default layout, import the Layout component
    // and use the following line.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    // return { default: page.default, layout: page.layout || Layout } as ResolvedComponent

    //return page
    return { default: page.default, layout: page.layout || Layout }

  },

  setup({ el, App, props }) {
    if (el) {
      mount(App, { target: el, props })
    } else {
      console.error(
        'Missing root element.\n\n' +
          'If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n' +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
    }
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: true,
    },
    future: {
      useDataInertiaHeadAttribute: true,
      useDialogForErrorModal: true,
      preserveEqualProps: true,
    },
  },
})
